module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[100]99.0d6f181.woff2";